import React, { useState, useEffect } from 'react';


function ToggleCard({ title, children, topLevelClass, active=false, headerClassName='', headerActions=null }) {
  const [isActive, setIsActive] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  const toggleBody = () => {
    setIsActive(!isActive);
  };


  return (
    <div 
        className={`card is-toggleable  ${isActive ? 'is-active' : ''} ${topLevelClass}`} 
    >
      <header className={`card-header is-clickable ${headerClassName || (isHovered ? 'has-background-white-ter' : '')}`}
            onClick={toggleBody}
            onMouseEnter={(e) => setIsHovered(true)}
            onMouseLeave={(e) => setIsHovered(false)}
            style={{ userSelect: 'none' }}
        >
        
          <p className={`card-header-title ${headerClassName ? 'has-text-white' : 'has-text-primary'}`}>
            {title}
          </p>
          {headerActions && (
            <div className="is-flex is-align-items-center mr-2" onClick={(e) => e.stopPropagation()}>
              {headerActions}
            </div>
          )}
        <button className="card-header-icon" aria-label="more options">
          <span className="icon">
            <i className={`${headerClassName ? 'has-text-white' : 'has-text-primary'} fas ${isActive ? 'fa-chevron-down' : 'fa-chevron-left'}`} />
          </span>
        </button>
      </header>
      {isActive && (
        <div className="card-content">
          <div className="content">
            {children}
          </div>
        </div>
      )}
    </div>
  );
}



export default ToggleCard;